import React from 'react';
import { ReactSVG } from 'react-svg';

import { TextField } from '../TextField';
import { isEmailValid } from './emailUtils';
import { classNames } from 'helpers';

const EmailTextField = ({
  value,
  onChange,
  error,
  disabled,
  cssClassName,
  placeholder="npr. info@example.com",
  ...props
}: any) => {
  const email = typeof value === 'string' ? value : '';

  const isValid = !email || isEmailValid(email);
  const showIcon = disabled && email && isValid;

  // Zastarjele vanjske greške uz unesenu vrijednost skriva TextField; kroz forceShowError
  // prolaze samo one koje vrijede i za ispravan email (npr. "email već postoji").
  const displayError = !isValid ? 'Neispravna email adresa' : error;

  const handleIconClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (email && isValid) {
      window.location.href = `mailto:${email}`;
    }
  };

  return (
    <div className="relative">
      <TextField
        {...props}
        value={email}
        onChange={onChange}
        error={displayError}
        placeholder={placeholder}
        inputMode="email"
        type="email"
        disabled={disabled}
        disableDebounce
        cssClassName={classNames(cssClassName, showIcon ? "pr-8" : "")}
      />
      {showIcon && (
        <button
          type="button"
          onClick={handleIconClick}
          className="absolute right-2 top-[54px] -translate-y-1/2 z-20 p-1 rounded hover:bg-blue-600 transition-colors duration-200 group"
          title={`Pošalji email na ${email}`}
        >
          <ReactSVG
            src="/media/icons/email.svg"
            className="w-5 h-5 text-blue-500 group-hover:text-white transition-colors duration-200"
          />
        </button>
      )}
    </div>
  );
};

export default React.memo(EmailTextField);
